import { Box, IconButton, List, ListItem, Paper, TextField, Tooltip, Typography } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { ThemeContext } from '../../context/ThemeContext'
import { useTranslation } from 'react-i18next'
import { getCookies } from '../../services/Cookies';
import { useSelector } from 'react-redux';
import { getStatmentReport } from '../../api/request/dashboard/dashboard';
import NewReport from '../../components/tab/tabview/reports/NewReport';
import DeleteReport from '../../components/tab/tabview/reports/DeleteReport';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import toast from 'react-hot-toast';

export default function Report() {
  const [reports, setReports] = useState([]);
  const { darkMode } = useContext(ThemeContext);
  const [open, setOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);
  const accountId = localStorage.getItem("accountID");
  const clientId = getCookies('clientId');
  const { userDetail } = useSelector((state) => state.user);
  const rawOffset = decodeURIComponent(getCookies('gmtOffset'));
  const [selectedReportName, setSelectedReportName] = useState("");
  const handleOpen = () => setOpen(true);
  const { t } = useTranslation()
  const [searchQuery, setSearchQuery] = useState('');

  const convertToDecimal = (offset) => {
    const [hours, minutes] = offset.split(':');
    const sign = offset.startsWith('-') ? -1 : 1;
    return sign * (Math.abs(parseInt(hours)) + (parseInt(minutes) / 60));
  };

  const gmtOffsetToSend = convertToDecimal(rawOffset);


  const handleDeleteOpen = (report) => {
    setSelectedReportName(report.name);
    setDeleteOpen(true);
  };

  useEffect(() => {
    const storedReports = JSON.parse(localStorage.getItem(`savedReports_${clientId}`)) || [];
    setReports(storedReports);
  }, []);

 
  const handleCreateReport = async (fromDate, toDate, reportType) => {
    const requestData = {
      accountID: accountId,
      clientID: clientId,
      companyName: "VFX-2",
      firstName: userDetail.firstName || "N/A",
      lastName: userDetail.lastName || "N/A",
      email: userDetail.email || "N/A",
      phone: userDetail.phone || "N/A",
      from: fromDate,
      gmtOffset: gmtOffsetToSend.toFixed(2),
      to: toDate,
    };

    try {
      const response = await getStatmentReport(requestData);
      if (response && response.data) {
        toast.success('Report grenerated')

        let reportContent = response.data;

        // Convert images to Base64 only if generating a PDF
        if (reportType === "pdf") {
          const convertImageToBase64 = async (url) => {
            try {
              const response = await fetch(url);
              const blob = await response.blob();
              return new Promise((resolve) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.readAsDataURL(blob);
              });
            } catch (error) {
              console.error("Error converting image to Base64:", error);
              return null; // Return null on error
            }
          };

          // Find and replace image URLs in the HTML with Base64 only for PDF
          const imgRegex = /<img[^>]+src=["'](https:\/\/[^"']+)["'][^>]*>/g;
          let matches = [...reportContent.matchAll(imgRegex)];

          for (let match of matches) {
            const imageUrl = match[1]; // Extract image URL
            const base64Image = await convertImageToBase64(imageUrl);
            if (base64Image) {
              reportContent = reportContent.replace(imageUrl, base64Image); // Replace URL with Base64
            } else {
              reportContent = reportContent.replace(match[0], ""); // Remove image tag if conversion fails
            }
          }
        }

        const currentDate = new Date().toISOString().split("T")[0];
        const fileName = `${fromDate}_${toDate}_${currentDate}.${reportType}`;

        const newReport = {
          name: fileName,
          datetime: currentDate,
          status: `${t('generated')}`,
          type: reportType,
          content: reportContent,
        };

        const updatedReports = [...reports, newReport];
        setReports(updatedReports);
        localStorage.setItem(`savedReports_${clientId}`, JSON.stringify(updatedReports));
      }
    } catch (error) {
      toast.error('Error generating report!');
      console.error("Error fetching report:", error);
    }
  };

  const handleDeleteReport = () => {
    if (!selectedReportName) return;
    const updatedReports = reports.filter(report => report.name !== selectedReportName);
    setReports(updatedReports);
    localStorage.setItem(`savedReports_${clientId}`, JSON.stringify(updatedReports));
    setDeleteOpen(false);
    setSelectedReportName("");
  };

  const handleDownload = async (reportToDownload) => {
    const clientId = getCookies('clientId');
    if (typeof setReports !== "function") {
      console.error("setReports is not a function:", setReports);
      return;
    }

    const storedReports = JSON.parse(localStorage.getItem(`savedReports_${clientId}`)) || [];
    const foundReport = storedReports.find((r) => r.name === reportToDownload.name);

    if (!foundReport) {
      console.error("Report not found in localStorage.");
      return;
    }

    const { type, content, name } = foundReport;

    if (type === "pdf") {
      const doc = new jsPDF("p", "mm", "a4");

      const element = document.createElement("div");
      element.innerHTML = content;
      document.body.appendChild(element);

      html2canvas(element, { scale: 2 }).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const imgWidth = 210;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;

        let y = 10;

        if (imgHeight > 290) {
          let pageHeight = 295;
          let heightLeft = imgHeight;
          let position = 0;

          doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
          heightLeft -= pageHeight;

          while (heightLeft > 0) {
            position = heightLeft - imgHeight;
            doc.addPage();
            doc.addImage(imgData, "PNG", 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
          }
        } else {
          doc.addImage(imgData, "PNG", 0, y, imgWidth, imgHeight);
        }

        doc.save(name);
        document.body.removeChild(element);
      });
    } else {
      const blob = new Blob([content], { type: "text/html" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = name;
      link.click();
    }

    // ✅ Update the status to "Downloaded"
    const updatedReports = storedReports.map((r) =>
      r.name === reportToDownload.name ? { ...r, status: `${'downloaded'}` } : r
    );

    setReports(updatedReports);
    localStorage.setItem(`savedReports_${clientId}`, JSON.stringify(updatedReports));
  };
  const filteredReports = reports.filter((report) => {
  const query = searchQuery.toLowerCase();
  return (
    report.datetime.toLowerCase().includes(query) ||
    report.status.toLowerCase().includes(query)
  );
});

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center" px={2} py={1}>
        <Box flex={1} display="flex" justifyContent="center">
          <Typography sx={{ color: darkMode ? "var(--lightText)" : "var(--darkText)" }}>{t('report')}</Typography>
        </Box>
        <Tooltip title={t('createReport')}>
          <IconButton onClick={handleOpen}><AddCircleOutlineIcon sx={{ fontSize: "20px" }} />
          </IconButton>
        </Tooltip>
      </Box>

      {/* <Divider /> */}
      <Box sx={{ backgroundColor: darkMode ? "#151924" : "#fff" }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <Paper sx={{ display: "flex", alignItems: "center", borderRadius: 0, width: "100%", padding: 0, backgroundColor: darkMode ? "#202933" : "#f1f1f1", }}>
            <TextField size="small" variant="outlined" placeholder="Search here..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)} sx={{ "& fieldset": { border: "none" }, flex: 1 }} />
          </Paper>
        </Box>
      </Box>
      <Paper style={{ width: "100%", height: '100%', backgroundColor: darkMode ? "#151924" : "#fff" }}>

        <List sx={{ backgroundColor: darkMode ? "#151924" : "#fff", padding: 0 }}>
          {filteredReports.map((report, index) => (
            <ListItem key={index} sx={{ display: "flex", flexDirection: "column", borderBottom: `1px solid ${darkMode ? "var(--borderDark)" : "var(--borderLight)"}`, py: 2, px: 1, gap: 1, }}>
              <Box sx={{ width: "100%" }}>
                <Typography variant="subtitle1" sx={{ color: darkMode ? "#fff" : "#000", fontWeight: 500 }}>{report.name}</Typography>
              </Box>

              <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                <Box>
                  <Typography variant="body2" color="textSecondary">{t('date')}: {report.datetime}</Typography>
                  <Typography variant="body2" color="textSecondary">{t('status')}: {report.status}</Typography>
                </Box>

                <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
                  <Tooltip title={t('download')}>
                    <IconButton size="small" onClick={() => handleDownload(report)}><DownloadOutlinedIcon size={14} style={{ color: 'var(--primary)' }} /></IconButton>
                  </Tooltip>
                  <Tooltip title={t('delete')}>
                    <IconButton size="small" onClick={() => handleDeleteOpen(report)}><DeleteOutlineIcon size={14} className='red' /></IconButton>
                  </Tooltip>
                </Box>
              </Box>
            </ListItem>
          ))}
        </List>
      </Paper>
      <NewReport open={open} handleClose={() => setOpen(false)} onCreateReport={handleCreateReport} />
      <DeleteReport open={deleteOpen} handleClose={() => setDeleteOpen(false)} handleDeleteReport={handleDeleteReport} />
    </>
  )
}
